<template>
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="fill: currentColor"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.29199 4.25C5.87778 4.25 5.54199 4.58579 5.54199 5V35C5.54199 35.4142 5.87778 35.75 6.29199 35.75H13.792C14.2062 35.75 14.542 35.4142 14.542 35V29.5H16.792V35C16.792 35.4142 17.1278 35.75 17.542 35.75H25.6678C26.082 35.75 26.4178 35.4142 26.4178 35V32.625H35.0415C35.4557 32.625 35.7915 32.2892 35.7915 31.875V10C35.7915 9.58579 35.4557 9.25 35.0415 9.25H26.4178V5C26.4178 4.58579 26.082 4.25 25.6678 4.25H6.29199ZM26.4178 10.75V31.125H34.2915V10.75H26.4178ZM7.04199 34.25V5.75H24.9178V34.25H18.292V28.75C18.292 28.3358 17.9562 28 17.542 28H13.792C13.3778 28 13.042 28.3358 13.042 28.75V34.25H7.04199ZM11.855 8.18677H8.85498V11.1868H11.855V8.18677ZM11.855 13.1868H8.85498V16.1868H11.855V13.1868ZM11.855 18.1868H8.85498V21.1868H11.855V18.1868ZM11.855 23.1868H8.85498V26.1868H11.855V23.1868ZM17.48 8.18677H14.48V11.1868H17.48V8.18677ZM17.48 13.1868H14.48V16.1868H17.48V13.1868ZM17.48 18.1868H14.48V21.1868H17.48V18.1868ZM17.48 23.1868H14.48V26.1868H17.48V23.1868ZM23.105 8.18677H20.105V11.1868H23.105V8.18677ZM23.105 13.1868H20.105V16.1868H23.105V13.1868ZM31.23 18.1868H28.23V21.1868H31.23V18.1868ZM31.23 23.1868H28.23V26.1868H31.23V23.1868ZM23.105 18.1868H20.105V21.1868H23.105V18.1868ZM23.105 23.1868H20.105V26.1868H23.105V23.1868ZM31.23 13.1868H28.23V16.1868H31.23V13.1868Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
